import PropTypes from "prop-types";
import eventType from "types/event.type";

export default PropTypes.objectOf(
	PropTypes.shape({
		id: PropTypes.number,
		event: eventType
	})
);
